import { IconThreeDotsVertical } from '@/theme/icons';
import rem from '@/utils/rem';
import { Icon, IconButton, Menu, MenuButton, MenuItem, MenuList, SpaceProps } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

type Props = {
  onClick?: () => void;
  onCancel: () => void;
  onDelete: () => void;
  showDoItLater?: boolean;
} & SpaceProps;

const ThreeDotsLaterButton = ({ onClick, onCancel, onDelete, showDoItLater = true, ...menuButtonProps }: Props) => {
  const { t } = useTranslation('ThreeDotsLaterButton');

  return (
    <Menu isLazy>
      <MenuButton
        as={IconButton}
        width="auto"
        height="auto"
        borderRadius={rem(6)}
        _hover={{ backgroundColor: 'background-secondary' }}
        _active={{
          backgroundColor: 'background-secondary',
        }}
        __css={{
          justifyContent: 'center',
          display: 'flex',
          alignItems: 'center',
        }}
        aria-label={t('ariaLabels.menu')}
        icon={<Icon as={IconThreeDotsVertical} boxSize={rem(14)} margin="0 auto" color="text-primary" />}
        variant="unstyled"
        {...menuButtonProps}
      />
      <MenuList
        zIndex="dropdown"
        width={rem(160)}
        minWidth="0"
        padding={rem(8)}
        borderWidth={rem(1)}
        borderStyle="solid"
        borderColor="gray.700"
        borderRadius={rem(8)}
        boxShadow="0px 2px 8px rgba(0, 0, 0, 0.2)"
        backgroundColor="background-primary"
      >
        {showDoItLater && onClick && (
          <MenuItem
            textStyle="small"
            padding={rem(12)}
            color="text-primary"
            borderRadius={rem(4)}
            _hover={{ backgroundColor: 'rgba(255, 255, 255, 0.1)' }}
            backgroundColor="transparent"
            onClick={onClick}
          >
            {t('menuItems.doItLater')}
          </MenuItem>
        )}
        <MenuItem
          textStyle="small"
          padding={rem(12)}
          color="text-primary"
          borderRadius={rem(4)}
          _hover={{ backgroundColor: 'rgba(255, 255, 255, 0.1)' }}
          backgroundColor="transparent"
          onClick={onCancel}
        >
          {t('menuItems.cancelActions')}
        </MenuItem>
        <MenuItem
          textStyle="small"
          padding={rem(12)}
          color="#F56565"
          borderRadius={rem(4)}
          _hover={{ backgroundColor: 'rgba(255, 255, 255, 0.1)' }}
          backgroundColor="transparent"
          onClick={onDelete}
        >
          {t('menuItems.deleteActions')}
        </MenuItem>
      </MenuList>
    </Menu>
  );
};

export default ThreeDotsLaterButton;
